<template>
  <div class="page">
    <br />
    <h1 class="title">Документы пользователя</h1>
    <div
      v-for="document in documents"
      :key="document.url"
      class="document-container"
    >
      <h3 class="document-title">{{ document.name }}</h3>
      <a
        :href="getFileDownloadUrl(document.url)"
        target="_blank"
        class="document-link"
        >Скачать</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config/index";

export default {
  computed: {
    ...mapGetters(["documents"])
  },
  methods: {
    getFileDownloadUrl(url) {
      return config.fileAbsUrl + url;
    }
  },
  mounted() {
    this.$store.dispatch("fetchDocuments");
  }
};
</script>

<style scoped>
.title {
  padding: 0 40px 20px;
  font-size: 25px;
}

.document-container {
  margin: 0 0 20px 40px;
  display: flex;
}

.document-title {
  font-weight: 400;
  font-size: 18px;
}

.document-link {
  margin-left: 20px;
  display: flex;
  align-items: center;
  text-decoration: none;
}
</style>
